<div>
  <Navbar />
  <Sidebar />
  <div class="page-wrapper">
    <div class="hero-section w-100  ">
      <div class="border border-secondary rounded-4 p-2">
        <!-- Header -->
        <div class="card shadow-sm mb-4">
        <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
            <div>
                <h4 class="mb-1">System Colours Configuration</h4>
                <p class="text-muted mb-0">Customize your organization's branding and theme</p>
            </div>
            <div class="d-flex gap-2">
                <button @click="reset_to_defaults" :disabled="saving" class="btn btn-outline-danger">
                <i class="fas fa-trash-restore me-2"></i>Reset to System Defaults
                </button>
                <button @click="save_configuration" :disabled="saving" class="btn upload-button text-white">
                <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
                <i v-else class="fas fa-check me-2"></i>
                {{ saving ? 'Saving...' : save_success ? 'Saved!' : 'Save Changes' }}
                </button>
            </div>
            </div>
        </div>
        </div>

        <div class="row">
        <!-- Color Configuration -->
        <div class="col-lg-6 mb-4">
            <div class="card shadow-sm h-100">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-4">
                <div class="d-flex align-items-center">
                    <i class="fas fa-palette text-primary me-2"></i>
                    <h5 class="mb-0">Brand Colours</h5>
                </div>
                <button @click="show_palette_suggestions = !show_palette_suggestions"
                    class="btn btn-sm btn-outline-primary">
                    <i class="fas fa-magic me-1"></i>Suggestions
                </button>
                </div>

                <!-- Primary Color -->
                <div class="mb-4">
                <label class="fw-semibold">Primary Colour</label>
                <div class="d-flex align-items-center gap-3">
                    <input type="color" v-model="primary_color"
                    @input="update_css_variables"
                    class="form-control form-control-color color-picker">
                    <input type="text" v-model="primary_color"
                    @input="update_css_variables"
                    class="form-control" placeholder="#8B0000">
                    <i v-if="!check_color_contrast(primary_color)"
                    class="fas fa-exclamation-triangle text-warning"
                    title="May have contrast issues with white text"></i>
                </div>
                </div>

                <!-- Secondary Color -->
                <div class="mb-4">
                <label class="fw-semibold">Secondary Colour</label>
                <div class="d-flex align-items-center gap-3">
                    <input type="color" v-model="secondary_color"
                    @input="update_css_variables"
                    class="form-control form-control-color color-picker">
                    <input type="text" v-model="secondary_color"
                    @input="update_css_variables"
                    class="form-control" placeholder="#4A4A4A">
                    <i v-if="!check_color_contrast(secondary_color)"
                    class="fas fa-exclamation-triangle text-warning"
                    title="May have contrast issues with white text"></i>
                </div>
                </div>

                <!-- Accent Color -->
                <div class="mb-4">
                <label class="fw-semibold">Accent Colour</label>
                <div class="d-flex align-items-center gap-3">
                    <input type="color" v-model="accent"
                    @input="update_css_variables"
                    class="form-control form-control-color color-picker">
                    <input type="text" v-model="accent"
                    @input="update_css_variables"
                    class="form-control" placeholder="#D4AF37">
                </div>
                </div>

                <div v-if="show_palette_suggestions" class="p-3 bg-light rounded">
                <h6 class="mb-3">Accessible Colour Palettes</h6>
                <div class="row g-2">
                    <div v-for="(palette, index) in palette_suggestions" :key="index"
                    class="col-6">
                    <div @click="apply_palette(palette)"
                        class="palette-card p-3 bg-white rounded border cursor-pointer"
                        :ref="'paletteCard' + index">
                        <div class="small fw-semibold mb-2">{{ palette.name }}</div>
                        <div class="d-flex gap-1">
                        <div class="palette-swatch palette-swatch-primary"></div>
                        <div class="palette-swatch palette-swatch-secondary"></div>
                        <div class="palette-swatch palette-swatch-accent"></div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>

        <!-- Logo Upload -->
        <div class="col-lg-6 mb-4">
            <div class="card shadow-sm h-100">
            <div class="card-body">
                <div class="d-flex align-items-center mb-4">
                <i class="fas fa-image text-primary me-2"></i>
                <h5 class="mb-0">Brand Assets</h5>
                </div>

                <!-- Organization Logo -->
                <div class="mb-4">
                <label class="fw-semibold">Organization Logo</label>
                <div class="upload-area border border-2 border-dashed rounded p-4 text-center"
                    @click="trigger_file_input('logo')">
                    <div v-if="logo_preview.logo">
                    <img :src="logo_preview.logo" alt="Logo preview"
                        class="img-fluid mb-3 logo-preview">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click.stop="trigger_file_input('logo')">
                        Change Logo
                    </button>
                    </div>
                    <div v-else>
                    <i class="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                    <p class="text-muted mb-2">Click to upload logo</p>
                    <p class="small text-muted mb-3">PNG, SVG, or JPG (max 2MB)</p>
                    <button type="button" class="btn btn-sm btn-secondary" @click.stop="trigger_file_input('logo')">
                        Choose File
                    </button>
                    </div>
                    <input type="file" ref="logoInput"
                    @change="handle_file_upload('logo', $event)"
                    accept="image/*" class="d-none">
                </div>
                </div>

                <!-- Favicon -->
                <div class="mb-4">
                <label class="fw-semibold">Favicon</label>
                <div class="upload-area border border-2 border-dashed rounded p-4 text-center"
                    @click="trigger_file_input('favicon')">
                    <div v-if="logo_preview.favicon">
                    <img :src="logo_preview.favicon" alt="Favicon preview"
                        class="mb-3 favicon-preview">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click.stop="trigger_file_input('favicon')">
                        Change Favicon
                    </button>
                    </div>
                    <div v-else>
                    <i class="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                    <p class="text-muted mb-2">Click to upload favicon</p>
                    <p class="small text-muted mb-3">ICO, PNG (16x16 or 32x32)</p>
                    <button type="button" class="btn btn-sm btn-secondary" @click.stop="trigger_file_input('favicon')">
                        Choose File
                    </button>
                    </div>
                    <input type="file" ref="faviconInput"
                    @change="handle_file_upload('favicon', $event)"
                    accept="image/x-icon,image/png" class="d-none">
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
        <!-- Live Preview -->
        <div class="card shadow-sm">
        <div class="card-body">
            <h5 class="mb-4">Live Preview</h5>
            <div class="border rounded p-4 bg-light">
            <div class="preview-container" ref="preview_container">
                <!-- Preview Header -->
                <div class="preview-header rounded p-4 mb-3 text-white">
                <div class="d-flex align-items-center mb-3">
                    <img v-if="logo_preview.logo" :src="logo_preview.logo" alt="Logo" class="me-3 logo-img">
                    <h3 class="mb-0">Your Organization</h3>
                    </div>
                    <p class="mb-0 opacity-75">This is how your primary colour will appear</p>
                </div>

                <!-- Preview Buttons -->
                <div class="d-flex gap-2 mb-3 flex-wrap">
                <button class="btn btn-preview-primary">
                    Primary Button
                </button>
                <button class="btn btn-preview-secondary">
                    Secondary Button
                </button>
                <button class="btn btn-preview-accent">
                    Accent Button
                </button>
                </div>

                <!-- Preview Card -->
                <div class="card border-0 shadow-sm card-preview">
                <div class="card-body">
                    <h5 class="card-title card-title-preview">
                    Sample Content Card
                    </h5>
                    <p class="card-text text-muted mb-3">
                    This preview shows how your brand colours will be applied throughout the interface.
                    </p>
                    <div class="d-flex gap-2">
                    <span class="badge badge-preview-primary">
                        Tag 1
                    </span>
                    <span class="badge badge-preview-accent">
                        Tag 2
                    </span>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>